import { graphql } from "relay-runtime"

export const deDeleteMedicalReportMutation = graphql`
  mutation deDeleteMedicalReportMutation($input: De_deleteMedicalReportAttachmentInput!, $connections: [ID!]!) {
    deleteMedicalReport: de_deleteMedicalReportAttachment(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      medicalReportAttachment {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
